import React from 'react';
import "./home.css";
import Social from './Social';
import Data from './Data';
import Head3D from './Head3D';

const Home = () => {
  return (
    <section className='home section' id='home'>
        <div className='home__container container grid'>
            <div className='home__content grid'>
                <Social/>
                <Head3D />
                <Data/>
            </div>
        </div>

    </section>
  )
}

export default Home